import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/service/Service'

const Index: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'内製化 内製化支援 Dev(Sec)Ops アジャイル開発 UIデザイン UXデザイン デザインスプリント'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/'}
        title="サービス | Aitria（アイトリア）"
        description="最新の技術を活かし、プロダクトやサービスの開発、DXの推進やシステムの内製化を支援します。アジャイル開発をはじめ、Dev(Sec)Ops支援、UIデザイン、UXデザイン、デザインスプリントなど、様々なデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default Index
